import React, { useState } from 'react';
import '../../styles/service-style/medical-rehabilitation.css';
import Footer from '../../components/Footer';
import { ChevronDown, ChevronUp } from 'lucide-react';
import manikanth from '../../assets/Rehab staff/Manikanth.JPG';
import VenkateshwarRao from '../../assets/Rehab staff/Venkateshwar rao.JPG';

const teamMembers = [
  {
    name: "K. Venkateshwar Rao",
    role: "Physio-Therapist",
    bio: "Passionate about helping patients restore movement and manage pain effectively.",
    image: VenkateshwarRao,
  },
  
];

const sections = [
  {
    title: 'Our Physiotherapy Services',
    items: [
      { heading: 'Assessment and Diagnosis', content: 'Our physiotherapists will assess your physical condition and diagnose the underlying cause of your symptoms.' },
      { heading: 'Personalized Treatment Plans', content: 'We will develop a customized treatment plan to address your specific needs and goals.' },
      { heading: 'Manual Therapy', content: 'Our physiotherapists use manual therapy techniques, such as massage, joint mobilization, and soft tissue mobilization, to promote healing and relaxation.' },
      { heading: 'Exercise Therapy', content: 'We will design an exercise program to help you strengthen, stretch, and improve your overall physical function.' },
      { heading: 'Physical Modalities', content: 'Our physiotherapists use physical modalities, such as heat, cold, electrical stimulation, and ultrasound, to promote healing and reduce pain.' },
      { heading: 'Hydrotherapy', content: 'We offer aquatic therapy and pool-based exercises to help you improve your physical function and mobility.' },
      { heading: 'Breathing Exercises and Respiratory Therapy', content: 'Our physiotherapists will teach you breathing exercises and provide respiratory therapy to help you manage respiratory conditions.' },
      { heading: 'Rehabilitation Programs', content: 'We offer rehabilitation programs for various conditions, including post-surgical, sports injuries, chronic pain, and neurological conditions.' },
    ],
  },
  {
    title: 'Who Can Benefit?',
    items: [
      { heading: 'Musculoskeletal Conditions', content: 'Conditions like back pain, arthritis, and sprains benefit greatly from physiotherapy interventions.' },
      { heading: 'Neurological Conditions', content: 'Stroke, spinal cord injuries, and Parkinson’s disease patients benefit from our neuro-rehab services.' },
      { heading: 'Cardiovascular Conditions', content: 'Heart disease and hypertension can be managed with supervised physiotherapy plans.' },
      { heading: 'Respiratory Conditions', content: 'Physiotherapy supports patients with asthma and chronic obstructive pulmonary disease (COPD).' },
      { heading: 'Pediatric Rehabilitation', content: 'We assist children with developmental delays, cerebral palsy, and other physical disabilities.' },
    ],
  },
  {
    title: 'Why Choose Us?',
    items: [
      { heading: 'Expert Care', content: 'Our licensed physiotherapists specialize in designing evidence-based, individualized treatment plans.' },
      { heading: 'Advanced Facilities', content: 'We provide modern rehabilitation equipment and hydrotherapy pools to support faster recovery.' },
      { heading: 'Compassionate Environment', content: 'We create a healing space where patients feel supported, heard, and motivated to recover.' },
    ],
  },
];

const PhysiotherapyServices = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleToggle = (index) => setActiveIndex((prev) => (prev === index ? null : index));

  return (
    <div>
      <div className="medical-rehab-page">
        <header className="medical-rehab-header">
          <h1 className="medical-rehab-title">Physiotherapy Services</h1>
          <p className="medical-rehab-intro">
            Welcome to the Department of Physiotherapy at Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center
          </p>
          <p className="medical-rehab-description">
            We are committed to restoring movement and improving the quality of life for our patients. Our physiotherapy services are tailored to meet the needs of individuals across all age groups and conditions — from post-surgical recovery to chronic pain management.
          </p>
        </header>

        <main className="medical-rehab-content">
          {sections.map((section, secIndex) => (
            <section key={secIndex} className="rehab-section">
              <h2 className="rehab-section-title">{section.title}</h2>
              <div className="rehab-accordion-grid">
                {section.items.map((item, idx) => {
                  const globalIdx = `${secIndex}-${idx}`;
                  const isActive = activeIndex === globalIdx;
                  return (
                    <div className={`rehab-accordion-item${isActive ? ' open' : ''}`} key={idx}>
                      <button
                        className="rehab-accordion-header"
                        onClick={() => handleToggle(globalIdx)}
                        aria-expanded={isActive}
                        aria-controls={`panel-${globalIdx}`}
                      >
                        <span className="icon">{isActive ? <ChevronUp /> : <ChevronDown />}</span>
                        {item.heading}
                      </button>
                      <div
                        id={`panel-${globalIdx}`}
                        className="rehab-accordion-body"
                        style={{ maxHeight: isActive ? '200px' : '0px' }}
                        aria-hidden={!isActive}
                      >
                        <p>{item.content}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          ))}

          <section className="rehab-commitment">
            <h2 className="rehab-section-title">Our Commitment</h2>
            <p>
              At Dr. Bharathi Rao Advanced Comprehensive Rehabilitation Center, we are committed to providing high-quality physiotherapy in a healing and professional environment. Your goals are our goals — and we’ll guide you every step of the way.
            </p>
          </section>

          <section className="rehab-team">
            <h2 className="rehab-section-title">Meet Our Team</h2>
            <div className="rehab-team-grid">
              {teamMembers.map((member, idx) => (
                <div key={idx} className="rehab-team-card">
                  <div className="rehab-team-img">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <div className="rehab-team-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="rehab-appointment">
            <h2 className="rehab-section-title">Book an Appointment</h2>
            <p>
              To know more about our <strong>Physiotherapy Services</strong> or to schedule an appointment, click the button below.
            </p>
            <a
              href="https://forms.gle/3kjZMUiW6qRyKpRh9"
              target="_blank"
              rel="noopener noreferrer"
              className="appointment-btn"
            >
              Book Now
            </a>
          </section>
        </main>

      </div>
      <Footer />

    </div>
  );
};

export default PhysiotherapyServices;
